import { render, staticRenderFns } from "./HomeWidgets.vue?vue&type=template&id=96fa2576&scoped=true"
import script from "./HomeWidgets.vue?vue&type=script&lang=ts"
export * from "./HomeWidgets.vue?vue&type=script&lang=ts"
import style0 from "./HomeWidgets.vue?vue&type=style&index=0&id=96fa2576&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fa2576",
  null
  
)

export default component.exports